
export * from '../../oauth2-provider-web/__liferay__/client.js';
